'use client'

import { useHeaderHeight } from 'hooks/useHeaderHeight/useHeaderHeight'
import { FiltersButton } from 'product-list/components/Filters/FiltersButton/FiltersButton'
import { Views } from 'product-list/components/Views/Views'
import type { View } from 'product-list/types/View'
import { cx } from 'utils/cx'
import styles from './Sticky.module.scss'

interface StickyProps {
	readonly displayViewSelector: boolean
	readonly displayFilters: boolean
	readonly additionalTopDistanceToSticky?: number
	readonly onUserViewSelect?: (view: View) => void
}

export function Sticky({
	displayFilters,
	displayViewSelector,
	additionalTopDistanceToSticky,
	onUserViewSelect,
}: StickyProps) {
	const { headerHeight } = useHeaderHeight()

	const onlyViewSelector = !displayFilters && displayViewSelector

	return (
		<div
			style={{
				top: `${headerHeight + (additionalTopDistanceToSticky ?? 0)}px`,
			}}
			className={styles.sticky}
		>
			{displayFilters && <FiltersButton />}
			{displayViewSelector && (
				<Views
					onUserViewSelect={onUserViewSelect}
					className={cx(onlyViewSelector && styles.onlyViewSelector)}
				/>
			)}
		</div>
	)
}
